import { createListPage } from 'pages/common/ListPage';
import { createTable } from 'pages/common/ListTable';

import { selectors, actions } from 'domain/runner';
import { filterParams } from 'filters/runner';

import { tableParams } from 'fields/runner';


const { list: items, onInlineEdit: edit, selected: selectedItems, loading, pagination } = selectors;
const { selectAction } = actions;

const Table = createTable({
  tableName: 'runnerList',
  tableParams,
  allowEdit: () => false,
  connections: {
    items,
    toggleRowCheck: selectAction,
    toggleAllSelected: selectAction,
    selectedItems,
    edit,
    loading,
    pagination,
  },
});

export default createListPage({
  name: 'Runner',
  pagination,
  filterParams,
  Table,
  softDelete: false,
});
